import {
  Icon,
  InlineStack,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Text,
} from '@customerio/pluma-components/react';
import { stateDescription } from '../catalog';
import { buildStatusOptions } from '../utils/state-options';
import { DeliveryStateTag } from './delivery-state-tag';

type StatusHeaderProps = {
  /** Available channels — determines which states the legend lists. */
  channels: readonly string[];
  /** Selected channel (`''` = all). */
  actionType: string;
};

/**
 * The "Status" column header with a hover help-popover that legends every
 * delivery/user-action state applicable to the current channel. Ported from
 * the Ember status-header + `StatusPopover`.
 */
export function StatusHeader({ channels, actionType }: StatusHeaderProps) {
  const groups = buildStatusOptions(channels, actionType);
  const states = groups.flatMap((group) => group.options.map((option) => option.value));

  return (
    <InlineStack alignBlock="center" alignInline="end" gap="050">
      <Text>Status</Text>
      <Popover
        shouldTriggerOnHover
        shouldTriggerOnClick={false}
        placement="bottom-end"
        unsafe_popoverStyle={{ maxWidth: '320px' }}
      >
        <PopoverTrigger>
          <Icon name="help" size="sm" color="subtle" />
        </PopoverTrigger>
        <PopoverContent p="200">
          <Stack gap="150">
            <Text weight="semibold">Delivery Status</Text>
            {states.map((state) => (
              <Stack key={state} gap="050">
                <DeliveryStateTag state={state} channel={actionType} />
                <Text size="s" color="subtle">
                  {stateDescription(state, actionType) ?? ''}
                </Text>
              </Stack>
            ))}
          </Stack>
        </PopoverContent>
      </Popover>
    </InlineStack>
  );
}
